// import { FaresCacheEvent } from "./faresCache.dto";

export const handleFaresCache = (data, rest, isRoundtrip) => {

    const outboundFares = createoutboundFares(rest.itinerary);
    const lang = getLang(data);

    const going = `${data.queryStore.origin}-${data.queryStore.destination}`;
    const returning = `${data.queryStore.destination}-${data.queryStore.origin}`;
    
    const eventData= {
        event: "fares_cache",
        passengers: {
            adt: parseInt(data.queryStore.ADT),
            chd: data.queryStore.CHD ? parseInt(data.queryStore.CHD) : 0,
            inf: data.queryStore.INF ? parseInt(data.queryStore.INF) : 0,
        },
        segment: isRoundtrip === false ? going : returning,
        tripType: data.queryStore.flightType,
        currency: rest.currency,
        market: rest.hm === 'OTHERS' ? 'OT' : rest.hm,
        lang: lang,
        outboundFares: outboundFares
    };


    return eventData;
};

const createoutboundFares = (data) => {
    return data
        .filter((element) => element.fareAmount !== 0)
        .map((element) => {
            return {
                price: element.fareAmount.toFixed(2),
                priceWithTaxes: element.fareAmountWithTaxes.toFixed(2),
                date: element.departureDate,
                cabin: 'economy',
                active: element.pricingInfo ? true : false,
                item_variant: element.stoppingAirports[0]?.operatingAirlineFlightNumber,
                stoppingAirports: validateStops(element.stoppingAirports),
            };
        });
};

const validateStops = (routes) => {
    let stops;
    if (routes && routes.length === 1) {
        routes = null;
    } else if (routes && routes.length > 1) {
        stops = `[${routes[0].destination}]`;
    }
    return stops;

}

export const getLang = (data) => {
    const url = data.hm;
    const lang = url.split("/")[1];
  
    return lang;
};
